import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

export const initMonitor = () => {
  Sentry.init({
    dsn: 'https://e34f0bf2d6db4696a4943b600c6eb91e@o4504599944364032.ingest.sentry.io/4504599983489024',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.5,
    environment: window.__ENV,
    // package.json's version (see .env), so an error says which release it came from.
    release: process.env.REACT_APP_VERSION ? `app-web@${process.env.REACT_APP_VERSION}` : undefined
  })
}

/**
 * An API error's own words never reach the page (flows/start/api.js, services/apiClient.js); they
 * come here instead, with the status and code, so a failure can still be read in Sentry.
 */
export const captureError = ({ error }) => {
  if (!error?.serverMessage) {
    Sentry.captureException(error)
    return
  }
  Sentry.captureException(error, {
    extra: { serverMessage: error.serverMessage, status: error.status, code: error.code }
  })
}
